'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalCard = exports.ModalCardUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _bound = require('redux/saga/entities/bound');

var _modals = require('redux/modules/modals');

var _ClassDetailCard = require('./ClassDetailCard');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
  var scheduleId = _ref.scheduleId;
  return {
    schedule: _bound.scheduleById.data(state, scheduleId)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  showModal: _modals.showModal
};

var ModalCardUnwrapped = exports.ModalCardUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ModalCardUnwrapped, _PureComponent);

  function ModalCardUnwrapped() {
    var _ref2;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, ModalCardUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ModalCardUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ModalCardUnwrapped)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleClick = function () {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          schedule = _this$props.schedule,
          showModal = _this$props.showModal;


      showModal('ClassDetailModal', {
        class: schedule.class,
        endtime: schedule.endtime,
        starttime: schedule.starttime,
        teacher: schedule.teacher,
        venue: schedule.venue
      });

      if (onClick) {
        onClick();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(ModalCardUnwrapped, [{
    key: 'render',
    value: function render() {
      var schedule = this.props.schedule;

      return schedule && _react2.default.createElement(
        _ClassDetailCard.ClassDetailCard,
        {
          endTime: schedule.endtime,
          klassName: schedule.class.name,
          startTime: schedule.starttime,
          venueName: schedule.venue.name
        },
        _react2.default.createElement(
          'a',
          { onClick: this.handleClick },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'modalcard.link',
            defaultMessage: 'See details'
          })
        )
      );
    }
  }]);
  return ModalCardUnwrapped;
}(_react.PureComponent);

ModalCardUnwrapped.propTypes = {
  onClick: _propTypes2.default.func,
  schedule: _propTypes2.default.shape({
    endtime: _propTypes2.default.number.isRequired,
    class: _propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired
    }).isRequired,
    starttime: _propTypes2.default.number.isRequired,
    venue: _propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  showModal: _propTypes2.default.func.isRequired
};

var ModalCard = exports.ModalCard = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ModalCardUnwrapped);